import { useToast, TYPE, POSITION } from 'vue-toastification';
const toast = useToast();

const options = {
    position: POSITION.BOTTOM_RIGHT,
    hideProgressBar: true,
    timeout: 4000,
};

export const showToast = (message: string) => toast.info(message, {
    ...options,
    type: TYPE.INFO,
});

export const errorToast = (message: string) => toast.error(message, {
    ...options,
    type: TYPE.ERROR,
});

export const successToast = (message: string) => toast.success(message, {
    ...options,
    type: TYPE.SUCCESS,
});